import { Button, Form } from "react-bootstrap"
import dayjs from "dayjs"

interface iPropsDateFiltro {
    inicial: string,
    final: string,
    handleChange: any,
    handleRefresh: any,
    handleArrow: any
}

const inputDatas:React.CSSProperties = {
    height: "41px",
    marginRight: "5px",
    marginLeft: "5px",
    maxWidth: "max-content"
}

export default function DateFiltro({ inicial, final, handleChange, handleRefresh, handleArrow }: iPropsDateFiltro) {

    function handleComando(comando: "futuro" | "passado") {
        const data = dayjs(inicial)
        if (comando === "futuro") {
            handleArrow(data.add(1, "day").format("YYYY-MM-DD"))
        }
        if (comando === "passado") {
            handleArrow(data.subtract(1, "day").format("YYYY-MM-DD"))
        }
    }

    return (
        <div id="filtro_date">
            <h1 className="titleMain">Métricas API's Requests</h1>
            <DataFiltradaPorExtenso data_inicial={inicial} data_final={final} />
            <div className="div-row">
                <Button className="btn_icon_lupa" onClick={() => { handleComando("passado") }} ><span className="material-symbols-outlined" style={{fontSize: "1.6em", lineHeight: "inherit"}}>arrow_back_ios_new</span></Button>
                <Form.Control name='data_inicial' type="date" id='data_inicial' value={inicial} placeholder="Data Inicial" style={inputDatas} onChange={
                    (event) => {
                        const dados = {
                            id: event.target.id,
                            value: event.target.value,
                        }
                        console.log(dados)
                        handleChange(dados)
                    }
                } />
                <Form.Control name='data_final' type="date" id='data_final' value={final} placeholder="Data Final" style={inputDatas} onChange={
                    (event) => {
                        const dados = {
                            id: event.target.id,
                            value: event.target.value,
                        }
                        console.log(dados)
                        handleChange(dados)
                    }
                } />
                <Button className="btn_icon_lupa" onClick={() => { handleComando("futuro") }} ><span className="material-symbols-outlined" style={{fontSize: "1.6em", lineHeight: "inherit"}}>arrow_forward_ios</span></Button>
                
                <div style={{width: "5px"}}></div>
                <Button className="btn_icon_lupa" onClick={handleRefresh} variant="success" ><span className="material-symbols-outlined" style={{fontSize: "1.6em", lineHeight: "inherit"}}>search</span></Button>
            </div>

            <a href="/metricas/sites" style={{textDecoration: 'none', position: 'absolute'}}>Logs_sites</a>
            
        </div>
    )
}

interface iPropsDataFiltro {
    data_inicial: string
    data_final: string
}
function DataFiltradaPorExtenso({ data_inicial, data_final }:iPropsDataFiltro) {
    let data:string = formatarDataParaExtenso(data_inicial)

    if (data_inicial !== data_final) {
        data = `${formatarDataParaExtensoSemAno(data_inicial)} ---- ${formatarDataParaExtensoSemAno(data_final)}`
    }

    function formatarDataParaExtenso(data_dia:string):string {
        return dayjs(data_dia).locale("pt-br").format("dddd, D * MMMM * YYYY").replaceAll("*", "de")
    }

    function formatarDataParaExtensoSemAno(data_dia:string):string {
        return dayjs(data_dia).locale("pt-br").format("dddd, D * MMMM").replaceAll("*", "de")
    }

    return (
        <div style={{ margin: "5px 0px" }}>
            <p><a href="/colaboradores" className="menu-sub-items-link" style={{color: "black"}}>Painel de Gestão - </a> {data}</p>
        </div>
    )
}
